import * as React from 'react';
import {GroupChart, InclinationChart, InclinationMidrangeChart, PronouncedLabels} from '../../components';
import { PonderaModal } from './PonderaModal';
import './Modal.css';
import './PVACharacteristicModal.css';

interface ModelContentProps {
    show: boolean;
    onHide: () => void;
    title: string;
    core: string;
    content: string;
    description: string;
    name?: string;
    step: number;
    value?: number;
    midLow?: number;
    midHigh?: number;
    allowToggle: boolean;
    activeColor?: string;
    customContentColor?: string;
    checkmarkUrl?: string;
    checkMarkRedUrl?: string;
}

export class PVACharacteristicModal extends React.Component<ModelContentProps> {
    constructor(props: ModelContentProps) {
        super(props);
    }

    render() {
        const complexContent = (
            <>
                <div className="characteristic-title-modal">{this.props.name}</div>
                <div dangerouslySetInnerHTML={{ __html: this.props.description }} />

                {!!this.props.value && 
                    <div className="chart-container single-area">
                        <PronouncedLabels />
                        <InclinationChart value={Math.round(this.props.value)} allowToggle={false} />
                    </div>
                }

                {/*{this.props.value !== undefined && <div className="inclination-table">*/}
                {/*    <div className="bg" />*/}
                {/*    <div className="cell">*/}
                {/*        <PronouncedLabels />*/}
                {/*    </div>*/}
                {/*    <div className="cell">*/}
                {/*        { !this.props.midLow && !this.props.midHigh && this.props.value !== undefined &&*/}
                {/*            <InclinationChart value={Math.round(this.props.value)} allowToggle={this.props.allowToggle} />*/}
                {/*        }*/}
                {/*        { this.props.midLow !== undefined && this.props.midHigh !== undefined && this.props.value !== undefined &&*/}
                {/*            <InclinationMidrangeChart value={Math.round(this.props.value)} midrangeLow={Math.round(this.props.midLow)} midrangeHigh={Math.round(this.props.midHigh)} />*/}
                {/*        }*/}
                {/*    </div>*/}
                {/*</div>}*/}
                
                <div dangerouslySetInnerHTML={{ __html: this.props.content }} />
            </>
        );

        return (
            <PonderaModal
                show={this.props.show}
                onHide={this.props.onHide}
                topic={this.props.core}
                title={`${this.props.title}`}
                content=""
                complexContent={complexContent}
                activeColor={this.props.activeColor}
                customContentColor={this.props.customContentColor}
                checkmarkUrl={this.props.checkmarkUrl}
                checkMarkRedUrl={this.props.checkMarkRedUrl}
            />
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/inclinationmodals/PVACharacteristicModal.tsx